import BaseController from '../..';
import { document } from '../../../../models/entities/common_subentities/document';
import IShipmentInternalDocuments from './IShipmentInternalDocuments';

export default class ShipmentInternalDocuments extends BaseController implements IShipmentInternalDocuments {
    constructor(baseUrl: string) {
        super(baseUrl);
    }
    async fetchShipmentInternalDocuments(shipmentId: string) {
        const response = await this.client.get(`/shipment/internal-documents/${shipmentId}`);
        return response;
    }
    async createMultipleShipmentInternalDocument(shipmentId: string, data: Array<document>) {
        // Upload each document individually since internal documents API doesn't support bulk upload
        const results = [];
        for (const document of data) {
            this.client.setBodyType('FORM-DATA');
            const response = await this.client.post(`/shipment/internal-documents/upload`, this.convertToFormData(document, shipmentId));
            results.push(response);
        }
        return results;
    }
    async createShipmentInternalDocument(shipmentId: string, data: document) {
        this.client.setBodyType('FORM-DATA');
        const response = await this.client.post(`/shipment/internal-documents/upload`, this.convertToFormData(data, shipmentId));
        return response;
    }
    async deleteShipmentInternalDocument(documentId: number) {
        const response = await this.client.delete(`/shipment/internal-documents`, JSON.stringify({ id: documentId }));
        return response;
    }
    private convertToFormData(document: document, shipmentId: string): FormData {
        const formData = new FormData();
        let type = document.type;
        if (Array.isArray(type)) {
            type = type.length === 1 ? type[0] : JSON.stringify(type);
        }
        formData.append('shipmentId', shipmentId);
        formData.append('type', type);
        formData.append('comment', document.comment);
        formData.append('fileName', document.fileName);
        formData.append('fileType', document.fileType);
        if (document.expDate) formData.append('expDate', document.expDate instanceof Date ? document.expDate.toISOString().split('T')[0] : document.expDate);
        if (document.file) formData.append('file', document.file);
        if (document.id) formData.append('id', '' + document.id);
        return formData;
    }
}